<template>
	<v-dialog v-model="dialog" persistent hide-overlay :width="width">
		<v-card>
			<v-card-title>About K4Ops</v-card-title>
			<v-card-subtitle>Copyright 2021 K4Connect, Inc.</v-card-subtitle>
			<v-card-text>
				<v-row v-if="version">
					<v-col cols="6">Web Version</v-col>
					<v-col cols="6">
						<span v-clip>
							{{ version.web }}
							<misc-copy-icon />
						</span>
					</v-col>
					<v-col cols="6">App Version</v-col>
					<v-col cols="6">
						<span v-clip>
							{{ version.app || "Unavailable" }}
							<misc-copy-icon />
						</span>
					</v-col>
				</v-row>
				<v-row v-if="user">
					<v-col cols="6">User</v-col>
					<v-col cols="6">
						<span v-clip>
							{{ fullName }}
							<misc-copy-icon />
						</span>
					</v-col>
					<v-col cols="6">Email</v-col>
					<v-col cols="6">
						<span v-clip>
							{{ email }}
							<misc-copy-icon />
						</span>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
	data() {
		return {
			dialog: true,
			app: null,
		};
	},

	computed: {
		...mapState("config", ["version"]),
		...mapState("auth", ["user"]),
		...mapGetters("auth", ["fullName", "email"]),

		width() {
			return this.$vuetify.breakpoint.xsOnly ? 300 : 500;
		},
	},
};
</script>
